import { ReactNode } from 'react';
import { usePermissions } from '@/context/PermissionsContext';
import type { PermissionValue } from '@/lib/permissions';

type CanCheck =
	| PermissionValue
	| {
			allOf?: PermissionValue[];
			anyOf?: PermissionValue[];
			not?: PermissionValue[];
	  };

export function Allowed({
	need,
	otherwise = null,
	children,
}: {
	need: CanCheck;
	otherwise?: ReactNode;
	children: ReactNode;
}) {
	const { allowed, can } = usePermissions();
	const ok =
		typeof need === 'string' ? allowed.has(need) : can(allowed, need as any);
	return <>{ok ? children : otherwise}</>;
}
